<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div> 
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>  
              <div v-html="formattedDescriptionNo(item.description_1)" class="description"></div> 
            </div>
          </div>
        </div>
      </div>
  </div>
      <!-- Contact Section (moved to the right) -->
      <!-- <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: +86 19883038871</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
      </div> -->
    </div>

</template>

<style src="@/assets/css/news.css" scoped></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/News/005/IEBPageimg1.png"),
            title: "云翰虹章公司正式入驻宁波诺丁汉国际创新创业产业园",
            description_no_1:`
            `,
            description_1:`
               2023年5月1日，云翰虹章正式入驻宁波诺丁汉大学的国际创新创业产业园的创新创业大楼。此次入驻旨在进一步加强与该大学在产学研方面的合作。

               诺丁汉国际创新创业产业园一期成立于2017年9月。该产业园以“国际引才“为主题，通过人才招募、成长指导、加速融资等多个角度为国外企业走进中国提供软着陆平台，并为中国企业走向国际提供配套服务。该产业园致力于建立一个国际技术与知识交流的平台，并打造一个国际化的创新中心。此外，在2020年度的宁波市科技企业孵化器认定名单中，诺丁汉国际创新创业产业园是该名单中6家单位中唯一一家以大学为运营主体的专业孵化器。

               未来，云翰虹章将加强技术研发力度，并通过与宁波诺丁汉国际创新创业产业园共同开展多项合作项目来拓展业务领域。双方将积极探索在数字资产、AIGC以及物联网等前沿领域的合作，共同推动科技成果转化和产业升级。
            `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/News/005/IEBPageimg1.png"),
            title:
              "Rosy Nebula officially settled in UNNC International Innovation and Entrepreneurship Industrial Park",
            description_no_1:`
            `,
            description_1:`
               On May 1, 2023, to establish industry-university-research cooperation with the university, Rosy Nebula officially settled in the IEB building of the UNNC International Innovation and Entrepreneurship Industrial Park.

               International Innovation and Entrepreneurship Industrial Park was set up in September 2017. With the theme of "International Talent Attraction", it provides supporting services for Chinese enterprises to go international and sets a platform for foreign enterprises to enter Chinese market by introducing talents, guiding development, and accelerating financing. The incubator wants to make IEB an international innovation center. What's more,  in the Ningbo Science and Technology Business Incubator recognition list in 2020, it is the only one based at university.
                
               In the future, Rosy Nebula will continue to strengthen its technological development and expand its business areas by jointly undertaking multiple cooperation projects with the International Innovation and Entrepreneurship Industrial Park. The two sides will actively explore cooperation opportunities in digital assets, AIGC, Internet of Things and other cutting-edge fields, and jointly promote the transformation of scientific and technological achievements and industrial upgrading.
            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
